import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

const DEFAULT_DURATION = 3000;
const DEFAULT_HORIZONTAL_POSITION = 'end';
const DEFAULT_VERTICAL_POSITION = 'top';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  showErrorMessage(message: string) {
    this.showNotification(message, 'error-snackbar');
  }

  showSuccessMessage(message: string) {
    this.showNotification(message, 'success-snackbar');
  }

  private showNotification(message: string, panelClass: string) {
    this.snackBar.open(message, 'Ausblenden', {
      duration: panelClass === 'error-snackbar' ? undefined : DEFAULT_DURATION,
      horizontalPosition: DEFAULT_HORIZONTAL_POSITION,
      verticalPosition: DEFAULT_VERTICAL_POSITION,
      panelClass: [panelClass],
    });
  }
}
